<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addPickupPlace()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'ADD_PICKUP_PLACE' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showPickupPlaces()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-pickup-place-list
          [pickupPlaces]="pickupPlaces"
          [meta]="meta"
          [loadingPickupPlaces]="loadingPickupPlaces"
          [defaultLanguage]="defaultLanguage"
          (selectedPickupPlace)="onSelectedPickupPlace($event)"
        ></app-pickup-place-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-spinner *ngIf="!pickupPlace"></app-spinner>
      <div *ngIf="pickupPlace">
        <app-pickup-place-detail
          [pickupPlace]="pickupPlace"
          [mode]="mode"
          [defaultLanguage]="defaultLanguage"
          [additionalLanguages]="additionalLanguages"
          [isModal]="true"
          (savedPickupPlace)="onSavedPickupPlace($event)"
          (canceledPickupPlace)="onCanceledPickupPlace()"
        ></app-pickup-place-detail>
      </div>
    </div>
  </div>
</div>
